"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ECategorieSocialProfessionnel_1 = require("../../enums/ClientSheet/ECategorieSocialProfessionnel");
const ECivility_1 = require("../../enums/ClientSheet/ECivility");
const EFiscalRegime_1 = require("../../enums/ClientSheet/EFiscalRegime");
const ELegalCapacity_1 = require("../../enums/ClientSheet/ELegalCapacity");
const EMaritalStatus_1 = require("../../enums/ClientSheet/EMaritalStatus");
const EMatrimonialRegime_1 = require("../../enums/ClientSheet/EMatrimonialRegime");
const ECreateClientGroups_1 = require("../../enums/ClientSheet/Groups/ECreateClientGroups");
const ECountry_1 = require("../../enums/Country/ECountry");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const AddressCreateRequestResource_1 = __importDefault(require("../Address/AddressCreateRequestResource"));
const Custom_1 = __importDefault(require("../decorators/Custom"));
const Resource_1 = __importDefault(require("../Resource"));
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
class ClientSheetCreateRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.civility = ECivility_1.ECivility.non_communique;
        this.politicallyExposed = false;
        this.personUS = false;
    }
}
exports.default = ClientSheetCreateRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.civility, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsEnum)(ECivility_1.ECivility, { groups: [ECreateClientGroups_1.ECreateClientGroups.civility, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "civility", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.lastName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.lastName, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_validator_1.IsString)({ groups: [ECreateClientGroups_1.ECreateClientGroups.lastName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.civility === ECivility_1.ECivility.madame)
            return true;
        obj.maidenName = null;
        return false;
    }, { groups: [ECreateClientGroups_1.ECreateClientGroups.maidenName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.maidenName, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_validator_1.IsString)({ groups: [ECreateClientGroups_1.ECreateClientGroups.maidenName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.maidenName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "maidenName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.firstName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.firstName, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)({ groups: [ECreateClientGroups_1.ECreateClientGroups.firstName, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.birthDate, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast, groups: [ECreateClientGroups_1.ECreateClientGroups.birthDate, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ groups: [ECreateClientGroups_1.ECreateClientGroups.birthDate, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ClientSheetCreateRequestResource.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.birthPlace, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.birthPlace, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_validator_1.IsString)({ groups: [ECreateClientGroups_1.ECreateClientGroups.birthPlace, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "birthPlace", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.birthDepartment, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.birthDepartment, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }, { groups: [ECreateClientGroups_1.ECreateClientGroups.birthDepartment, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "birthDepartment", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.birthCountry, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry, { groups: [ECreateClientGroups_1.ECreateClientGroups.birthCountry, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "birthCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.nationality, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry, { groups: [ECreateClientGroups_1.ECreateClientGroups.nationality, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "nationality", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.profession, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.profession, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "profession", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.nif, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.nif, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "nif", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.email, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsEmail)(undefined, { groups: [ECreateClientGroups_1.ECreateClientGroups.email, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.email, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, CustomAsync_1.default)((email, args) => {
        const spouse = args.object.spouse;
        return email !== spouse?.email;
    }, {
        message: ValidationErrors_1.EValidationError.isSameEmailThanSpouse,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.mobilePhone, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsNumberString)({ no_symbols: false }, { groups: [ECreateClientGroups_1.ECreateClientGroups.mobilePhone, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsPhoneNumber)("FR", { groups: [ECreateClientGroups_1.ECreateClientGroups.mobilePhone, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, CustomAsync_1.default)((mobilePhone, args) => {
        const spouse = args.object.spouse;
        return mobilePhone !== spouse?.mobilePhone;
    }, {
        message: ValidationErrors_1.EValidationError.isSamePhoneThanSpouse,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.taxResidenceCountry, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry, { groups: [ECreateClientGroups_1.ECreateClientGroups.taxResidenceCountry, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "taxResidenceCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.legalCapacity, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsEnum)(ELegalCapacity_1.ELegalCapacity, { groups: [ECreateClientGroups_1.ECreateClientGroups.legalCapacity, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, Custom_1.default)((value) => value === ELegalCapacity_1.ELegalCapacity.majeur_capable, { message: ValidationErrors_1.EValidationError.blockOperation, groups: [ECreateClientGroups_1.ECreateClientGroups.legalCapacity, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateRequestResource.prototype, "legalCapacity", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.politicallyExposed, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsBoolean)({ groups: [ECreateClientGroups_1.ECreateClientGroups.politicallyExposed, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateRequestResource.prototype, "politicallyExposed", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.personUS, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_validator_1.IsBoolean)({ groups: [ECreateClientGroups_1.ECreateClientGroups.personUS, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, Custom_1.default)((value) => value === false, { message: ValidationErrors_1.EValidationError.personUSmustBeFalse, groups: [ECreateClientGroups_1.ECreateClientGroups.personUS, ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateRequestResource.prototype, "personUS", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.maritalStatus] }),
    (0, class_validator_1.IsEnum)(EMaritalStatus_1.EMaritalStatus, { groups: [ECreateClientGroups_1.ECreateClientGroups.maritalStatus] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "maritalStatus", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.maritalStatus === EMaritalStatus_1.EMaritalStatus.marie || obj.maritalStatus === EMaritalStatus_1.EMaritalStatus.pacse)
            return true;
        obj.matrimonialRegime = null;
        return false;
    }, { groups: [ECreateClientGroups_1.ECreateClientGroups.matrimonialRegime] }),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.matrimonialRegime] }),
    (0, class_validator_1.IsEnum)(EMatrimonialRegime_1.EMatrimonialRegime, { groups: [ECreateClientGroups_1.ECreateClientGroups.matrimonialRegime] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "matrimonialRegime", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.fiscalRegimes] }),
    (0, class_validator_1.ArrayNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.fiscalRegimes] }),
    (0, class_validator_1.IsEnum)(EFiscalRegime_1.EFiscalRegime, { each: true, groups: [ECreateClientGroups_1.ECreateClientGroups.fiscalRegimes] }),
    (0, Custom_1.default)((value) => value.includes(EFiscalRegime_1.EFiscalRegime.BIC) || value.includes(EFiscalRegime_1.EFiscalRegime.IRPP) || value.includes(EFiscalRegime_1.EFiscalRegime.BNC) || value.includes(EFiscalRegime_1.EFiscalRegime.AUTRE_NON_RESIDENT), {
        message: ValidationErrors_1.EValidationError.mustIncludeBicOrIrppOrBnc,
        groups: [ECreateClientGroups_1.ECreateClientGroups.fiscalRegimes],
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ClientSheetCreateRequestResource.prototype, "fiscalRegimes", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.agreementElectronicDocument] }),
    (0, class_validator_1.IsBoolean)({ groups: [ECreateClientGroups_1.ECreateClientGroups.agreementElectronicDocument] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateRequestResource.prototype, "agreementElectronicDocument", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AddressCreateRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.address] }),
    (0, class_validator_1.ValidateNested)({ groups: [ECreateClientGroups_1.ECreateClientGroups.address] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", AddressCreateRequestResource_1.default)
], ClientSheetCreateRequestResource.prototype, "address", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ClientSheetCreateRequestResource),
    (0, class_validator_1.ValidateNested)({ groups: [ECreateClientGroups_1.ECreateClientGroups.spouse] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", ClientSheetCreateRequestResource)
], ClientSheetCreateRequestResource.prototype, "spouse", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECreateClientGroups_1.ECreateClientGroups.nonProfessionalClassificationAcknowledgment] }),
    (0, class_validator_1.IsBoolean)({ groups: [ECreateClientGroups_1.ECreateClientGroups.nonProfessionalClassificationAcknowledgment] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "nonProfessionalClassificationAcknowledgment", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60, { groups: [ECreateClientGroups_1.ECreateClientGroups.lineOfBusiness, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [60] }),
    (0, class_validator_1.MinLength)(1, { groups: [ECreateClientGroups_1.ECreateClientGroups.lineOfBusiness, ECreateClientGroups_1.ECreateClientGroups.spouse], context: [1] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "lineOfBusiness", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ECategorieSocialProfessionnel_1.ECategorieSocialProfessionnel, { groups: [ECreateClientGroups_1.ECreateClientGroups.categorieSocialProfessionnel] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateRequestResource.prototype, "categorieSocialProfessionnel", void 0);
